/** Bind async list/map work to the exact submitted selection. This changes no
 * query, ranking or buy gate; completion order must not choose the user's cars. */
export class ObsoleteSearchError extends Error {
  constructor() { super('This search has been superseded'); this.name = 'ObsoleteSearchError' }
}

export function createSearchSession() {
  let current = null, sequence = 0, cachedMap = null, pendingMap = null
  const isCurrent = ticket => Boolean(ticket && ticket === current)
  return {
    begin(filters, page, sortBy) {
      // SearchFilters owns editable draft arrays. Never let later draft edits
      // alter the submitted selection used by retry, pagination or the map.
      const snapshot = Object.freeze(Object.fromEntries(Object.entries(filters).map(([key, value]) =>
        [key, Array.isArray(value) ? Object.freeze([...value]) : value])))
      current = Object.freeze({ id: ++sequence, filters: snapshot, page, sortBy })
      cachedMap = null; pendingMap = null
      return current
    },
    current: () => current,
    isCurrent,
    invalidate() { current = null; cachedMap = null; pendingMap = null },
    map(ticket, load) {
      if (!isCurrent(ticket)) return Promise.reject(new ObsoleteSearchError())
      if (cachedMap?.ticket === ticket) return Promise.resolve(cachedMap.rows)
      if (pendingMap?.ticket === ticket) return pendingMap.promise
      const promise = Promise.resolve().then(() => {
        if (!isCurrent(ticket)) throw new ObsoleteSearchError()
        return load()
      }).then(rows => {
        if (!isCurrent(ticket)) throw new ObsoleteSearchError()
        if (!Array.isArray(rows)) throw new Error('Invalid map response')
        cachedMap = { ticket, rows }
        return rows
      }).finally(() => { if (pendingMap?.promise === promise) pendingMap = null })
      pendingMap = { ticket, promise }
      return promise
    },
  }
}
